import script from "./HomepageDesignmuseumgentBuilding.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageDesignmuseumgentBuilding.vue?vue&type=script&setup=true&lang=js"

import "./HomepageDesignmuseumgentBuilding.vue?vue&type=style&index=0&id=5897ed74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5897ed74"]])

export default __exports__